
export class LoginData {
    username: string | null;
    password: string | null;
    bearerToken: string | null;
    isRememberMeOn: boolean;
    mfaDeviceId: string;
    userDeviceId: string | null;
    useMockServer: boolean;
    clearStoredCredentials: boolean;

    constructor(value?: Partial<LoginData>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
